export const GENERATE_OTP = '/static/generateOtp';
export const VERIFY_OTP = '/static/verify';

export const GET_IP_ADDRESS = 'https://api.ipify.org/?format=json';
export const DOCUMENT_UPLOAD = '/file/upload?bucket=hbt-seva';
export const DOCUMENT_DELETE = '/file/delete?key=';
export const DOCUMENT_ATTACHMENT_DELETE = '/notes/remove-attachment?';

export const ADD_NOTES_DETAILS = '/notes/add';
export const EDIT_NOTES_DETAILS = '/notes/edit';
export const GET_NOTES_DETAILS = '/notes/get';
export const DELETE_NOTES = '/notes/delete?noteId=';

//Tickets

export const ADD_TICKET = '/ticket/add';
export const GET_TICKETS = '/ticket/list';
export const UPDATE_TICKET = '/ticket/edit';
export const DELETE_TICKET = '/ticket/delete?ticketNo=';
export const GET_USERS = '/user/users';
export const UNIQUE_ID = '/generic/uniqueid?prefix=';
export const REQ_ID = '/generic/uniqueid-req';
export const REFERRAL_DATA_BY_CONTACT = '/ticket/ref-contact?number=';
export const GET_NOTES_BY_TICKET = '/ticket/byId?ticketNo=';

export const GET_NOTES = '/notes/list';
export const ASSIGNED_TO = '/ticket/handler';
export const TTD_DATES = '/ticket/ttd-dates';
export const TTD_DETAILS = '/ticket/ttd-details';

export const TICKET_STATS = '/ticket/status-count';

export const GET_CALENDAR_EVENTS = '/calender/event-list';

export const CREATE_CALENDAR_EVENT = '/calender/add-event';

export const UPDATE_CALENDAR_EVENT = '/calender/update-event';

export const DELETE_CALENDAR_EVENT = '/calender/delete?eventId=';

export const GET_AUDIT_HISTORY = '/generic/audit-history';

//budget and news

export const ADD_BUDGET_NEWS = '/generic/add-budget-news';
export const UPDATE_BUDGET_NEWS = '/generic/edit-budget-news';
export const LIST_BUDGET_NEWS = '/generic/list-budget-news';

export const LATEST_NEWS = '/static/news';
export const REMOVE_BUDGET_NEWS = '/generic/remove-budget-news?';

export const ADD_EDIT_USER = '/user/add-edit';
export const GET_ROLES = '/user/role';
export const DELETE_USER = '/user/remove?id=';

//Images
export const ADD_IMAGE = '/crm/add-image';
export const GET_IMAGES = '/static/list-images';
export const DELETE_IMAGE = '/crm/remove-image?key=';

//Mandal Village

export const GET_MANDALS = '/generic/mandal-village?constituency=';
export const GET_CONSTITUENCIES = '/generic/mandal-village?district=';
export const GET_VILLAGES = '/generic/mandal-village?mandalName=';
export const GET_DISTRICTS = '/generic/mandal-village?state=';

export const IP_LOOKUP = '/ip/lookup?ip=';

export const S3_SIGNED_URL = '/file/url';

//TTD

export const GET_ALL_TTD_REQ = '/ttd/list';
export const ADD_TTD_REQ = '/ttd/add';
export const UPDATE_TTD_REQ = '/ttd/edit';
export const GET_TTD_REQ = '/ttd/byId';
export const DELETE_TTD_REQ = '/ttd/delete';

//Job Requests
export const GET_ALL_JOB_REQUESTS = '/job/list';
export const UPDATE_JOB_REQUESTS = '/job/edit';
